// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-32ccf0bf] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.header .admin_add[data-v-32ccf0bf] {\n  float: right;\n  width: 100px;\n  height: 30px;\n  font-size: 12px;\n  border: none;\n  background-color: #2A82E4;\n  border-radius: 5px;\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
